/*=========================================================================================
  File Name: moduleNoteMutations.js
  Description: Note Module Mutations
==========================================================================================*/

export default {
	// API
	SET_NOTES(state, notes) {
		state.notes = notes;
	},

	ADD_NOTE(state, note) {
		state.notes = [note, ...state.notes];
	},

	UPDATE_NOTE(state, note) {
		const noteIndex = state.notes.findIndex(t => t.id === note.id);
		if(noteIndex !== -1) {
			Object.assign(state.notes[noteIndex], note);
		}
	},

	DELETE_NOTE(state, noteId) {
		state.notes = state.notes.filter(note => note.id !== noteId);
	},

	SET_TOTAL_NOTES(state, total) {
		state.total = total;
	},

	SET_IS_HAS_MORE_PAGES(state, isHasMorePages) {
		state.isHasMorePages = isHasMorePages;
	}
};
